import {formateData, headers} from "./index";
import {applicationName} from "../utils";

export const storyMoneyListInitDataSource = (start, size, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/storyMoney/list?"+formateData({
        start,size
    });
    fetch(url, {
        method: 'get',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include'
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:storyMoneyListInitDataSource",error);
        callBack({});
    })
};
export const storyMoneyAdd = (storyMoney, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/storyMoney/add";
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData(storyMoney)
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:storyMoneyListInitDataSource",error);
        callBack({});
    })
};
export const storyMoneyUpdate = (storyMoney, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/storyMoney/edit";
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData(storyMoney)
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:storyMoneyListInitDataSource",error);
        callBack({});
    })
};
export const storyMoneyDelete = (id, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/storyMoney/deleteById";
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData(id)
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:storyMoneyListInitDataSource",error);
        callBack({});
    })
};
export const storyMoneyDeletes = (ids, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/storyMoney/deleteByIds";
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: {
            ...headers,
            "Content-Type" : 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify(ids)
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:storyMoneyListInitDataSource",error);
        callBack({});
    })
};